






























































import mixins from 'vue-typed-mixins';
import SurveyUtils, { Survey } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Survey,
    },
  },
  computed: {
    visible(): boolean {
      return !!this.value;
    },
  },
  data(): {
    duplicate: Survey['name'];
    error?: string;
  } {
    return {
      duplicate: {
        admin: '',
        public: {},
      },
      error: undefined,
    };
  },
  methods: {
    async submit() {
      try {
        (this.$refs.alert as any).hide('submit');
        const id = await SurveyUtils.api.survey.duplicate({
          id: this.value.id as number,
          name: this.duplicate,
        });
        await this.$router.push({
          name: 'survey-edit-details',
          params: { id: id.toString() },
        });
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.add', {
            values: [this.duplicate.admin],
          }),
        });
        this.$emit('input', undefined);
      } catch (error) {
        // use ref so error is shown in the modal
        (this.$refs.alert as any).show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },
    cancel() {
      this.$emit('input', undefined);
    },
  },
  watch: {
    value() {
      this.duplicate = {
        admin: '',
        public: {},
      };
    },
  },
});
